import Http from '@/api/http.js'

export default {
  instanceStatus(instance_name = 'CimentaoPrincipal') {
    return Http.get('/whatsapp/instance_status', {
      params: { instance_name },
    })
  },
  getQrcode(instance_name = 'CimentaoPrincipal') {
    return Http.get('/whatsapp/qrcode', {
      params: { instance_name },
    })
  },
}

